import { safeFetchAPI } from '@/api';
import { utils } from '@/helpers';
import { DiscountTemplate } from '@/types';
import { create } from 'zustand';

type DiscountTemplatesStoreState = {
	loaded: boolean;

	discountMap: Record<string, DiscountTemplate>;
};

type DiscountTemplatesStoreActions = {
	loadDiscounts: () => Promise<Record<string, DiscountTemplate>>;
};

type DiscountTemplatesStore = DiscountTemplatesStoreState & DiscountTemplatesStoreActions;

export const useDiscountTemplatesStore = create<DiscountTemplatesStore>((set, get) => ({
	loaded: false,
	discountMap: {},

	async loadDiscounts() {
		const [discountsList, error] = await safeFetchAPI<DiscountTemplate[]>('/discount/:uid');

		if (error) {
			utils.toaster?.addToast?.({
				placement: 'top',
				message: error || 'Error loading discounts',
				type: 'danger',
			});
			return {};
		}

		const discountMap: Record<string, DiscountTemplate> = {};

		for (const discount of discountsList ?? []) {
			discountMap[discount.id] = discount;
		}

		set({ discountMap, loaded: true });
		return discountMap;
	},
}));
